// extracted by mini-css-extract-plugin
export default {"body":"loader_body__tLfP6","loader":"loader_loader__d0byq","loader__image":"loader_loader__image__PuyU+","loader__coin":"loader_loader__coin__c+Ibh","flip":"loader_flip__tahvB"};